<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>

<!-- mini reset css-->
<style lang="scss">
@import "./assets/fonts/fontello/css/fontello.css";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-base;
}
body {
  margin: 0;
  padding: 0;
  background: $background;
}
</style>



// WEBPACK FOOTER //
// src/App.vue?d9a473aa